import { render } from "./Inp-1.vue?vue&type=template&id=a65b8a18"
import script from "./Inp-1.vue?vue&type=script&lang=js"
export * from "./Inp-1.vue?vue&type=script&lang=js"

import "./Inp-1.vue?vue&type=style&index=0&id=a65b8a18&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__